<template>
  <div class="purchaseIntentEdit">
    <el-collapse
      v-model="activeNames"
      :class="{
        'collapse-main-content': buttonList.length > 0,
        'collapse-main-no-content': buttonList.length == 0,
      }"
    >
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <SiruiSearch
            ref="formItem"
            :query="params"
            :columns="columns"
            :isQueryPanel="false"
            :rules="rules"
            @changeMethod="changeMethod"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2" v-if="!isCreate">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            关联合同
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab" @tab-click="tabClick">
            <el-tab-pane label="关联合同" name="first">
              <div class="detail">
                <ProjectRelationInfo
                  :isEdit="true"
                  :defaultData="params.orderDOList || []"
                ></ProjectRelationInfo>
              </div>
            </el-tab-pane>
            <!--招标详情-->
            <el-tab-pane v-if="params.winBidResult" label="招标详情" name="six">
              <div class="detail">
                <ProjectResultInfo
                  ref="historyInfo"
                  :result="params"
                  :disabled="true"
                ></ProjectResultInfo>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>

      <!-- <div class="prodcut"> </div> -->
      <!--附件-->
      <el-collapse-item name="3">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <IEUploadFileType
            ref="upload"
            :tableData="uploadTableData || []"
            @upload="handleUpload"
            :isShowDownBtn="isShowDownBtn"
            dictType="PROJECT_INITIATION"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="text-center">
      <template v-if="!opreationType">
        <!-- 新建、已保存、已驳回可以保存 -->
        <el-button
          v-if="
            !params.projectInitiationStatus ||
            ['PIS01', 'PIS03', 'PIS07'].includes(params.projectInitiationStatus)
          "
          type="primary"
          :disabled="isDisabled"
          @click="saveHandle(1)"
        >
          保存
        </el-button>
        <!-- 已保存、已驳回可以提交 -->
        <el-button
          v-if="
            !params.projectInitiationStatus ||
            ['PIS01', 'PIS03', 'PIS07'].includes(params.projectInitiationStatus)
          "
          type="primary"
          @click="saveHandle(0)"
          :disabled="isDisabled"
        >
          提交
        </el-button>
        <!-- 已生效可以关闭 -->
        <el-button
          v-if="['PIS04', 'PIS05'].includes(params.projectInitiationStatus)"
          type="primary"
          @click="closeHandle"
        >
          关闭
        </el-button>
        <!-- 已关闭可以取消关闭 -->
        <el-button
          v-if="['PIS06'].includes(params.projectInitiationStatus)"
          type="primary"
          @click="cancelCloseHandle"
        >
          取消关闭
        </el-button>
        <!-- 已保存、已驳回可以删除 -->
        <el-button
          v-if="['PIS01', 'PIS03'].includes(params.projectInitiationStatus)"
          type="primary"
          @click="deleteHandle"
        >
          删除
        </el-button>
        <el-button
          type="primary"
          v-if="['PIS07', 'PIS031'].includes(params.projectInitiationStatus)"
          @click="saveHandle(2)"
          >立项变更</el-button
        >
        <el-button
          type="primary"
          v-if="['PIS02'].includes(params.projectInitiationStatus)"
          @click="withdrawApprovalHandler"
          >撤回审批</el-button
        >
      </template>
      <template v-else>
        <el-button type="primary" @click="saveApprover()"> 保存运管审批人 </el-button>
      </template>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import ProjectRelationInfo from './components/project-relation-info';
  import ProjectApi from '@/api/purchaseSalesCenter/project.js';
  import BASE_API from '@/api/dataBase.js';
  import API from '@/api/masterData/personnel';
  import { dateFormatter } from '@/common/js/util';
  import ProjectResultInfo from './components/projectResultInfo';
  import cooperationApi from '@/api/masterData/cooperation.js';
  import {
    formColumn,
    formRules,
    settlementCenterColumn,
    // downstreamSteelMillColumn,
  } from './projectCreate.js';
  import { mapNumToString } from '@/utils';
  export default {
    name: 'projectCreate',
    data() {
      return {
        activeNames: ['1', '2', '3'],
        tabActiveName: 'first',
        params: {
          projectInitiationCreateDate: dateFormatter(new Date()),
          operaterNo: null,
          operatorName: null,
          applyDepartmentNo: null,
          applyDepartmentName: null,
          applyCompanyNo: null,
          applyCompanyName: null,
          chargePersonNo: null,
          chargePersonName: null,
          projectInitiationNo: null,
          projectNo: null,
          projectName: null,
          projectAbbreviation: null,
          businessType: null,
          businessTypeName: null,
          customerNo: null,
          customerName: null,
          recyclingtCompany: [],
          platformtCompany: [],
          recyclingtCompanyName: [],
          platformtCompanyName: [],
          projectProvince: null,
          projectProvinceCode: null,
          projectCitys: null,
          projectCity: null,
          projectCityCode: null,
          enterpriseType: null,
          enterpriseTypeName: null,
          projectUsageQuotaWan: null,
          projectReceivableQuotaWan: null,
          projectIncomePoint: null,
          projectAccountingPeriod: null,
          monthlySupply: null,
          operatingRevenueTarget: null,
          receiptToAddress: null,
          subjectMatter: [],
          subjectMatterName: [],
          paymentMethod: null,
          paymentMethodName: null,
          collectionCycle: null,
          warrantyClause: null,
          remark: null,
          winBidResult: null,
          winBidAmount: null,
          winBidContractNo: null,
          biddingManagementFee: null,
          biddingPackageMoneyMethod: null,
          reason: null,
          specificReason: null,
          projectInitiationStatus: null,
          bidStatus: null,
          closeBeforeStatus: null,
          type: 0,
          apr: '',
          partnerZhName: null,
          abbreviation: null,
          creditCode: null,
          legalPerson: null,
          // enterpriseType: null,
          establishedDate: null,
          registeredAssets: null,
          actualAssets: null,
          isDomestic: null,
          province: null,
          city: null,
          invoiceAddress: null,
          invoicePhone: null,
          invoiceBankName: null,
          invoiceBankAccount: null,
          isSignGovernmentAgreement: null,
          // governmentAgreementValidityPeriod: null,
          isPromiseSettlementCost: null,
          // settlementCostTerm: null,
          isGuarantor: null,
          // dateGuarantee: null,
          isNeedTaxCushion: null,
          monthlyInvoiceQuantity: null,
          invoiceFaceValue: null,
          nowPurchasedInvoice: null,
          availableInvoiceAmount: null,
          settlementCost: null,
          valueAddedTaxTaxRate: null,
          operationManagementCenter: null,
        },
        companyList: [],
        departmentList: [], // 部门
        companyList0: [], // 回收公司
        companyList1: [], // 平台公司
        //附件
        uploadTableData: [],
        load: false,
        buttonList: [],
        isEdit: true,
        isCreate: true, // 是否新建
        isView: false,
        id: null,
        isFirst: false,
        formDisabled: false,
        isShowDownBtn: false,
        printShow: false,
        yesOrNo: [
          { value: '0', label: '否' },
          { value: '1', label: '是' },
        ],
        showProCity: false,
        checkPartner: [],
        isDisabled: false,
        opreationType: false, //判断是否为编辑运管审批人
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictListMap: (state) => state.dict.dictListMap,
      }),
      getDictLabel() {
        return (value, dicName) => {
          if (!value) return null;
          if (!this.dictListMap || !Object.prototype.hasOwnProperty.call(this.dictListMap, dicName))
            return null;
          const obj = this.dictListMap[dicName].find((v) => v.value == value);
          if (!obj) return null;
          return obj.label;
        };
      },
      columns() {
        if (this.params.businessType == 'PIBT03') {
          return settlementCenterColumn(this);
        }
        // else if (this.params.businessType == 'PIBT02') {
        //        return downstreamSteelMillColumn(this);
        //      }
        else {
          return formColumn(this);
        }
      },
      rules() {
        return formRules(this);
      },
    },
    created() {
      //获取详情
      this.isView = this.$route.query.isView?.toString() == 'true' || false;
      this.isEdit = this.$route.query.isEdit.toString() == 'true';
      this.isCreate = this.$route.query.isCreate?.toString() == 'true' || false;
      this.opreationType = this.$route.query?.opreationType == 'editApprover' ? true : false;
      console.log(this.opreationType, '操作');
      this.id = this.$route.query.id || null;
      if (this.id) {
        const visitedViews = this.$store.state.tagsView.visitedViews;
        const last = visitedViews[visitedViews.length - 1];
        if (last.name == 'projectCreate') {
          last.meta.title = '编辑项目立项';
        }
        visitedViews[visitedViews.length - 1] = last;
        this.$store.dispatch('tagsView/coverVisitedView', visitedViews);
      }
      this.isView && this.getOrderDetail();
      this.getCompany();
    },
    mounted() {
      if (this.isCreate) {
        this.getData();
        this._getCompanyApi0(
          this.userInfo.userInfo.companyCode,
          this.userInfo.userInfo.departmentCode
        );
      }
      this._getCompanyApi1(this.userInfo.userInfo.tenantCode);
      console.log(this.params);
    },
    methods: {
      // 保存运管审批人
      async saveApprover() {
        const { data } = await this.$axios.post(ProjectApi.SAVE_APPROVER, {
          id: this.params.id,
          operationManagementCenter: this.params.operationManagementCenter,
        });
        if (data.code == 0) {
          this.$message.success(data.msg || '操作成功');
          this.cancel();
        } else {
          this.$message.error(data.msg);
        }
      },
      // 撤回审批
      withdrawApprovalHandler() {
        this.loading.startLoading();
        this.$axios
          .post('/sales/projectInitiation/batchWithdrawProjectInitiation', {
            ids: [this.$route.query.id],
            oaId: this.userInfo.oaId,
          })
          .then((res) => {
            const { code, msg } = res.data;
            this.loading.endLoading();
            if (code == 0) {
              this.$message.success('撤回成功');
              this.getOrderDetail();
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      async getCompany() {
        // 获取公司数据
        let res = await this.$baseRequest.getCompanyList();
        console.log('公司=====', res);
        if (res) {
          this.companyList = res;
          // 默认初始化全部表单数据
          if (this.params.applyCompanyNo) {
            // 获取部门下拉
            this._getDepartmentByCompanyCodeApi(this.params.applyCompanyNo);
          }
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        if (companyCode) {
          const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          });
          if (data.code == 0) {
            console.log(data.data?.personDepartmentInfo, '---???');
            this.departmentList = data.data?.personDepartmentInfo.map((item) => {
              return {
                label: item.personDepartmentName,
                value: item.personDepartmentCode,
              };
            });
          } else {
            console.error('获取部门失败');
          }
        }
      },
      // 回收公司
      async _getCompanyApi0(companyCode, departmentCode) {
        this.params.recyclingtCompanyName = [];
        this.params.recyclingtCompany = [];
        const { data } = await this.$axios.post(cooperationApi.LIST_PARTNEREXTEND, {
          partnerTypes: 'HZHB02,HZHB03,HZHB11',
          departmentCode: departmentCode,
          companyCode: companyCode,
        });
        if (data.code == 0) {
          this.companyList0 = data.data?.map((item) => {
            return {
              label: item.partnerZhName,
              value: item.partnerCode,
            };
          });
        } else {
          console.error('获取回收公司失败');
        }
      },
      // 平台公司
      async _getCompanyApi1(tenantCode) {
        const { data } = await this.$axios.get(`${BASE_API.LISTDATA_SERECHCOMPANY}/${tenantCode}`);
        if (data.code == 0) {
          this.companyList1 = Object.freeze(data.data);
        } else {
          console.error('获取公司失败');
        }
      },
      async getDepartList() {
        return new Promise((resolve) => {
          this.$axios
            .post(API.LISTDATA_SERECHDEPARTMENT + `/${this.params.applyCompanyNo}`)
            .then((res) => {
              resolve(res.data?.data);
            });
        });
      },
      async getCityList(value) {
        console.log(value);
        let parent = null;
        if (value) {
          parent = value;
        } else {
          parent = this.params.projectProvinceCode;
        }
        console.log(parent, 'parent');
        return new Promise((resolve) => {
          this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + parent).then((res) => {
            resolve(res.data?.data);
          });
        });
      },
      // 初始化数据
      getData() {
        console.log(this.userInfo);
        this.params.applyCompanyName = this.userInfo.userInfo.companyName;
        this.params.applyCompanyNo = this.userInfo.userInfo.companyCode;
        this.params.applyDepartmentNo = this.userInfo.userInfo.departmentCode;
        this.params.applyDepartmentName = this.userInfo.userInfo.departmentName;
        this.params.operaterNo = this.userInfo.userInfo.personNo;
        this.params.operatorName = this.userInfo.userInfo.personName;
        this.params.chargePersonName = this.userInfo.userInfo.personName;
        this.params.chargePersonNo = this.userInfo.userInfo.personNo;
      },
      tabClick() {
        const expands = document.querySelectorAll('.expandTable .vxe-table--expanded');
        if (expands) {
          expands.forEach((item) => {
            item.style.display = 'none';
          });
        }
      },
      getOrderDetail() {
        this.initFlag = true;
        this.loading.startLoading();
        this.$axios
          .post(ProjectApi.PROJECT_DETAIL, {
            id: this.id,
          })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              let data = res.data.data;
              this.uploadTableData = data.attachmentList || [];
              this._getCompanyApi0(data.applyCompanyNo, data.applyDepartmentNo);
              if (data.applyCompanyNo) {
                this._getDepartmentByCompanyCodeApi(data.applyCompanyNo);
              }
              data.chargePerson = [
                {
                  personNo: this.params.chargePersonNo || null,
                  personName: this.params.chargePersonName || null,
                },
              ];
              data.customer = [
                {
                  partnerCode: this.params.customerNo || null,
                  partnerZhName: this.params.customerName || null,
                },
              ];
              this.isFirst = true;
              this.formDisabled = ['PIS02', 'PIS04', 'PIS05', 'PIS06', 'PIS08'].includes(
                data.projectInitiationStatus
              );
              this.isShowDownBtn = ['PIS02', 'PIS04', 'PIS05', 'PIS06', 'PIS08'].includes(
                data.projectInitiationStatus
              );
              if (this.opreationType) {
                this.formDisabled = true;
                this.isShowDownBtn = true;
              }
              let newObj = mapNumToString(data);

              this.params = Object.assign({}, this.params, newObj, {
                platformtCompany: newObj.platformtCompanyName
                  ? newObj.platformtCompanyName.split(',')
                  : '',
                platformtCompanyName: newObj.platformtCompany
                  ? newObj.platformtCompany.split(',')
                  : '',
                recyclingtCompany: newObj.recyclingtCompanyName
                  ? newObj.recyclingtCompanyName.split(',')
                  : '',
                recyclingtCompanyName: newObj.recyclingtCompany
                  ? newObj.recyclingtCompany.split(',')
                  : '',
                governmentAgreementValidityPeriod: newObj.governmentAgreementValidityPeriod
                  ? newObj.governmentAgreementValidityPeriod.split(',')
                  : '',
                settlementCostTerm: newObj.settlementCostTerm
                  ? newObj.settlementCostTerm.split(',')
                  : '',
                dateGuarantee: newObj.dateGuarantee ? newObj.dateGuarantee.split(',') : '',
                subjectMatter: newObj.subjectMatter ? newObj.subjectMatter.split(',') : '',
                subjectMatterName: newObj.subjectMatterName
                  ? newObj.subjectMatterName.split(',')
                  : '',
              });
              if (this.params.isDomestic != 'CN') {
                this.showProCity = true;
              } else {
                this.showProCity = false;
              }
              // this.params.projectCitys = this.params.projectCityCode
              //   ? {
              //       value: this.params.projectCityCode,
              //       label: this.params.projectCity,
              //     }
              //   : null;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      // 社会统一代码校验去重
      handleInputHover() {
        if (this.params.creditCode && this.params.creditCode == '') {
          return;
        }
        let params = {
          creditCode: this.params.creditCode,
          departmentCode: this.params.applyDepartmentNo, // 查询当前部门是否重复
          requestStatus: 'ZT03', //【ID1002169】 只有已生效的可以扩展【合作伙伴主数据】已驳回状态仍可以扩展
        };
        this.$axios.post(cooperationApi.GET_CHECKING_PARTNER, params).then((res) => {
          console.log('长度', res);
          if (res.data.code === 0) {
            console.log(res.data);
            this.checkPartner = res.data.data;
            this.handleExpand();
          }
        });
      },
      // 打开提醒弹窗
      handleExpand() {
        console.log('长度', this.checkPartner);
        if (this.checkPartner.length > 0) {
          this.isDisabled = true;
          this.$confirmAction(this.$t('合作伙伴已存在，无需重复校验！'), '')
            .then(() => {
              // this.returnPath();
            })
            .catch(() => {});
        } else {
          this.isDisabled = false;
        }
      },
      async changeMethod(obj) {
        console.log('修改', obj, this.params.isDomestic);

        if (obj.prop == 'isSignGovernmentAgreement') {
          if (this.params.isSignGovernmentAgreement == '0')
            this.params = {
              ...this.params,
              governmentAgreementValidityPeriod: '',
            };
        }
        if (obj.prop == 'isGuarantor') {
          if (this.params.isGuarantor == '0') {
            this.params = {
              ...this.params,
              dateGuarantee: '',
            };
          }
        }
        if (obj.prop == 'isPromiseSettlementCost') {
          if (this.params.isPromiseSettlementCost == '0') {
            this.params = {
              ...this.params,
              settlementCostTerm: '',
              unlimitedSettlementCostTerm: '',
            };
          }
        }
        if (obj.prop == 'unlimitedSettlementCostTerm') {
          if (
            !(
              this.params.isPromiseSettlementCost == '1' &&
              this.params.unlimitedSettlementCostTerm == '0'
            )
          ) {
            this.params = {
              ...this.params,
              settlementCostTerm: '',
            };
            // this.params.settlementCostTerm = '';
          }
        }

        if (obj.prop == 'creditCode') {
          this.handleInputHover();
        }
        if (obj.prop == 'isDomestic') {
          this.params.city = '';
          this.params.province = '';
          if (this.params.isDomestic != 'CN') {
            this.showProCity = true;
          } else {
            this.showProCity = false;
          }
        }
        if (obj.prop == 'province') {
          this.clearValidate();
          this.params.city = '';
        }
        console.log('----', this.showProCity);
        if (obj.prop == 'applyCompanyNo') {
          if (this.params.applyCompanyNo) {
            let item = this.$utils.find(this.companyList, (item) => item['value'] === obj.val);
            this.params.applyCompanyName = item?.label;
          } else {
            this.params.applyCompanyName = null;
          }
          // 调用回收公司
          this._getCompanyApi0(this.params.applyCompanyNo, this.params.applyDepartmentNo);
          // 加载部门
          if (this.params.applyCompanyNo) {
            this._getDepartmentByCompanyCodeApi(this.params.applyCompanyNo);
          }
          this.params.applyDepartmentNo = null;
        }
        if (obj.prop == 'applyDepartmentNo') {
          if (this.params.applyDepartmentNo) {
            const departMap = await this.getDepartList();
            const departs = departMap.find((v) => {
              return v.value == this.params.applyDepartmentNo;
            });
            if (departs) {
              this.params.applyDepartmentName = departs.label;
            } else {
              this.params.applyDepartmentName = null;
            }
          } else {
            this.params.applyDepartmentName = null;
          }
          // 调用回收公司
          this._getCompanyApi0(this.params.applyCompanyNo, this.params.applyDepartmentNo);
        }
        if (obj.prop == 'projectProvinceCode') {
          this.params.projectCity = null;
          this.params.projectCityCode = null;
          this.params.projectCitys = null;
          this.params.projectProvinceCode = obj.val;
          this.params.projectProvince = this.dictListMap.province.find(
            (v) => v.value == obj.val
          )?.label;
        }
        if (obj.prop == 'projectCity') {
          this.params.projectCity = obj.val.label;
          this.params.projectCityCode = obj.val.value;
          console.log(this.params);
        }
        if (obj.prop == 'chargePersonName') {
          this.params.chargePersonNo = obj.val ? obj.val[0].personNo : null;
          this.params.chargePersonName = obj.val ? obj.val[0].personName : null;
        }
        if (obj.prop == 'customerName') {
          this.params.customerNo = obj.val ? obj.val[0].partnerCode : null;
          this.params.customerName = obj.val ? obj.val[0].partnerZhName : null;
          // this.params.receiptToAddress = obj.val ? obj.val[0].streetAddress : null;
          this.params.enterpriseType =
            obj.val && obj.val[0] && obj.val[0].enterpriseType
              ? obj.val[0].enterpriseType
              : this.params.enterpriseType;
          this.params.projectProvinceCode = obj.val ? obj.val[0].province : null;
          if (this.params.projectProvinceCode) {
            this.params.projectProvince = this.dictListMap.province.find(
              (v) => v.value == this.params.projectProvinceCode
            )?.label;
          }
          this.params.projectCityCode = obj.val ? obj.val[0].city : null;
          if (this.params.projectCityCode) {
            const cityMap = await this.getCityList();
            const citys = cityMap.find((v) => {
              return v.value == this.params.projectCityCode;
            });
            if (citys) {
              // this.params.projectCitys = {
              //   value: this.params.projectCityCode,
              //   label: citys.label,
              // };
              this.params.projectCity = citys.label;
            }
          } else {
            this.params.projectCityCode = '';
            this.params.projectCity = '';
          }
        }
        if (obj.prop == 'subjectMatter') {
          // if (this.params.subjectMatter) {
          //   this.params.subjectMatterName = this.getDictLabel(
          //     this.params.subjectMatter,
          //     'PROJECT_INITIATION_SUBJECT_MATTER'
          //   );
          // }
        }
        if (obj.prop == 'businessType') {
          if (this.params.businessType) {
            this.clearValidate();
            let dataObj = {
              projectInitiationCreateDate: this.params.projectInitiationCreateDate,
              operatorName: this.params.operatorName,
              applyCompanyNo: this.params.applyCompanyNo,
              applyCompanyName: this.params.applyCompanyName,
              applyDepartmentNo: this.params.applyDepartmentNo,
              applyDepartmentName: this.params.applyDepartmentName,
              chargePersonName: this.params.chargePersonName,
              businessType: this.params.businessType,
              city: '',
              province: '',
            };
            this.params = dataObj;
            console.log(dataObj, '数据！！！');
            this.params.businessTypeName = this.getDictLabel(
              this.params.businessType,
              'PROJECT_INITIATION_BUSINESS_TYPE'
            );
            this.$forceUpdate();
            console.log(this.params, '初始数据');
          }
        }
        if (obj.prop == 'paymentMethod') {
          if (this.params.paymentMethod) {
            this.params.paymentMethodName = this.getDictLabel(
              this.params.paymentMethod,
              'payment_method'
            );
          }
        }
        if (obj.prop == 'enterpriseType') {
          if (this.params.enterpriseType) {
            this.params.enterpriseTypeName = this.getDictLabel(
              this.params.enterpriseType,
              'enterprise_type'
            );
          }
        }
        // 回收公司
        if (obj.prop == 'recyclingtCompanyName') {
          const selectList = obj.val;
          console.log(selectList, 'partnerCode11partnerZhName');
          // this.params.recyclingtCompanyName = selectList.map((item) => item.partnerZhName).join(',');
          // this.params.recyclingtCompany = selectList.map((item) => item.partnerCode).join(',');
        }
        // 平台公司
        if (obj.prop == 'platformtCompanyName') {
          const selectList = obj.val;
          console.log(selectList, '222');
          // this.params.platformtCompany = selectList.join(',');
          // this.params.platformtCompanyName = this.companyList1
          //   .filter((item) => selectList.includes(item.value))
          //   .join(',');
          // if (this.params.platformtCompanyName) {
          //   this.params.platformtCompanyName = this.companyList1.find(
          //     (item) => item.value == obj.val
          //   ).label;
          //   this.params.platformtCompany = obj.val;
          // }
        }
      },
      //上传回调
      handleUpload(uploadTableData) {
        this.uploadTableData = uploadTableData;
      },
      cancelCloseHandle() {
        if (this.load) return;
        this.loading.startLoading();
        let id = this.$route.query.id;
        this.load = true;
        this.$axios
          .post(ProjectApi.CANCEL_CLOSE_PROJECT, {
            id: Number(id),
          })
          .then((res) => {
            this.load = false;
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.cancel(false);
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      closeHandle() {
        if (this.load) return;
        this.loading.startLoading();
        let id = this.$route.query.id;
        this.load = true;
        this.$axios
          .post(ProjectApi.CLOSE_PROJECT, {
            id: Number(id),
          })
          .then((res) => {
            this.load = false;
            this.loading.endLoading();
            if (0 == res.data.code) {
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              this.cancel(false);
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //删除项目
      deleteHandle() {
        this.$confirmAction()
          .then(() => {
            let id = this.$route.query.id;
            this.load = true;
            this.$axios
              .post(ProjectApi.DELETE_PROJECT, {
                id: Number(id),
              })
              .then((res) => {
                this.load = false;
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: this.$t('message.success'),
                  });
                  this.cancel(false);
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      clearValidate() {
        this.$nextTick(() => {
          this.$refs.formItem.clearValidate();
        });
      },
      //跳转到列表页面
      cancel() {
        let path = {
          fromPath: {
            path: '/projectInitiation/projectCreate',
            name: 'projectCreate',
            meta: {
              keepAlive: true,
              title: '编辑项目立项',
            },
          },
          toPath: {
            path: '/projectInitiation/projectOverview',
            name: 'projectOverview',
            meta: {
              keepAlive: false,
              title: '项目立项总览',
            },
            query: {
              // contractDetailCategory: 'HT04',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      handleValueToNumber(query) {
        const numberNameList = [
          'projectUsageQuotaWan',
          'projectReceivableQuotaWan',
          'projectIncomePoint',
          'projectAccountingPeriod',
          'monthlySupply',
          'operatingRevenueTarget',
          'collectionCycle',
          'winBidAmount',
        ];
        for (let i = 0; i < numberNameList.length; i++) {
          const element = numberNameList[i];
          if (Object.prototype.hasOwnProperty.call(query, element) && query[element]) {
            query[element] = Number(query[element]);
          }
        }
        return query;
      },
      // 保存
      async saveHandle(type) {
        console.log('点击了', this.load);
        //基本信息-验证
        try {
          this.$refs.formItem.validate(async (valid, formData) => {
            if (valid) {
              console.log(formData, '--表单数据->>');
              //附件信息
              const attachment = this.uploadTableData.map((item, index) => {
                const result = Object.assign(
                  {},
                  {
                    sortNo: index,
                  },
                  item
                );
                return result;
              });
              console.log(formData, '表单数据', this.userInfo, this.dictListMap.enterprise_type);
              const enterpriseTypeName = this.dictListMap.enterprise_type.find(
                (item) => item.value == formData.enterpriseType
              )?.label;
              formData.governmentAgreementValidityPeriod =
                formData.governmentAgreementValidityPeriod
                  ? formData.governmentAgreementValidityPeriod.toString()
                  : '';
              formData.settlementCostTerm = formData.settlementCostTerm
                ? formData.settlementCostTerm.toString()
                : '';
              formData.dateGuarantee = formData.dateGuarantee
                ? formData.dateGuarantee.toString()
                : '';
              let params = {
                ...formData,
                oaId: this.userInfo.userInfo.oaId,
                type,
                enterpriseTypeName: enterpriseTypeName,
                tenantCode: this.userInfo.userInfo?.tenantCode,
                companyCode: this.userInfo.userInfo?.companyCode,
                departmentCode: this.userInfo.userInfo?.departmentCode,
                companyName: this.userInfo.userInfo?.companyName,
                departmentName: this.userInfo.userInfo?.departmentName,
              };
              if (this.params.businessType != 'PIBT03') {
                params.apr = +(+formData.apr).toFixed(2);
                params.platformtCompanyName = this.companyList1
                  .filter((item) => formData.platformtCompanyName.includes(item.value))
                  .map((item) => item.label)
                  .join(',');
                params.platformtCompany = formData.platformtCompanyName.join(',');
                params.recyclingtCompanyName = this.companyList0
                  .filter((item) => formData.recyclingtCompanyName.includes(item.value))
                  .map((item) => item.label)
                  .join(',');
                params.recyclingtCompany = formData.recyclingtCompanyName.join(',');
                console.log('subjectMatter', formData.subjectMatter);
                params.subjectMatter = formData.subjectMatter?.length
                  ? formData.subjectMatter.join(',')
                  : '';
                params.subjectMatterName =
                  this.dictListMap?.PROJECT_INITIATION_SUBJECT_MATTER.filter((item) =>
                    formData.subjectMatter?.includes(item?.value)
                  )
                    .map((item) => item?.label)
                    .join(',');
              }
              if (this.params.businessType == 'PIBT03') {
                params.isDomesticName = this.dictListMap.person_national.find(
                  (item) => item.value == formData.isDomestic
                )?.label;
                if (this.params.isDomestic == 'CN') {
                  params.provinceName = this.dictListMap.province.find(
                    (item) => item.value == formData.province
                  )?.label;
                  if (params.city) {
                    const cityMap = await this.getCityList(formData.province);
                    console.log(cityMap, '1111');
                    const citys = cityMap.find((v) => {
                      return v.value == params.city;
                    });
                    if (citys) {
                      params.cityName = citys.label;
                    }
                  }
                } else {
                  params.cityName = '';
                  params.provinceName = '';
                  params.city = '';
                  params.province = '';
                }
              }
              //附件信息
              params.attachmentList = attachment;
              // params = this.handleValueToNumber(params);
              // if (type == 1) {
              //   params = { ...params, type: 1 };
              // }
              console.log(params, '提交数据');
              this.loading.startLoading();
              this.$axios
                .post(ProjectApi.SAVE_PROJECT, params)
                .then((res) => {
                  this.load = false;
                  this.loading.endLoading();
                  if (0 == res.data.code) {
                    this.$message({
                      type: 'success',
                      message: this.$t('message.success'),
                    });
                    // if (type == 1) {
                    //   this.isCreate = false;
                    //   // this.isEdit = true;
                    //   this.isView = true;
                    //   this.id = res.data.data.id;
                    // }
                    this.cancel();
                  } else {
                    this.$alert(res.data.msg);
                  }
                })
                .catch((e) => {
                  console.log(e);
                  this.load = false;
                  this.loading.endLoading();
                });
            } else {
              this.$message.error('请填写数据');
            }
          });
        } catch (error) {
          console.log(error);
          this.load = false;
        }
      },
    },
    components: {
      ProjectRelationInfo,
      ProjectResultInfo,
    },
  };
</script>
<style lang="scss" scoped>
  .prodcut {
    margin-bottom: 11px;
    background-color: #fff;
  }

  .detail {
    padding-bottom: 0px;
  }

  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
